import i18n from '@src/plugins/i18n'
const abbreviate = function(
  number,
  maxPlaces = 2,
  forcePlaces = 2,
  forceLetter = false
) {
  number = Number(number)
  forceLetter = forceLetter || false
  if (forceLetter !== false) {
    return annotate(number, maxPlaces, forcePlaces, forceLetter)
  }
  var abbr
  if (number >= 1e12 && maxPlaces < 13) {
    abbr = 'T'
  } else if (number >= 1e9 && maxPlaces < 10) {
    abbr = 'B'
  } else if (number >= 1e6 && maxPlaces < 7) {
    abbr = 'M'
  } else if (number >= 1e3 && maxPlaces < 5) {
    abbr = 'K'
  } else {
    abbr = ''
  }
  return annotate(number, maxPlaces, forcePlaces, abbr)
}

function annotate(number, maxPlaces, forcePlaces, abbr) {
  // set places to false to not round
  var rounded = 0
  if (!number) return 0
  switch (abbr) {
    case 'T':
      rounded = number / 1e12
      break
    case 'B':
      rounded = number / 1e9
      break
    case 'M':
      rounded = number / 1e6
      break
    case 'K':
      rounded = number / 1e3
      break
    case '':
      rounded = number
      break
  }
  if (maxPlaces !== false) {
    var test = new RegExp('\\.\\d{' + (maxPlaces + 1) + ',}$')
    if (test.test('' + rounded)) {
      rounded = rounded.toFixed(maxPlaces)
    }
  }
  if (Number(number) >= 10 ** maxPlaces && forcePlaces !== false) {
    rounded = Number(rounded).toFixed(forcePlaces)
  }
  return i18n.n(rounded) + '' + abbr
}
export default abbreviate
